import React from "react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import AppRoutes from "./routes";
import { createTheme, ThemeProvider } from '@mui/material/styles';


const theme = createTheme({
  palette: {
    primary: {
      main: '#1a103d',  // purple
    },
    secondary: {
      main: '#f7c948',  // gold
    },
    background: {
      default: '#f1f1f1',  // grey
    },
  },
  typography: {
    // You can add custom typography if needed
  },
  // Optionally add component overrides here for buttons, modals, etc.
});
const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>

        <AppRoutes />


      </Provider>
    </ThemeProvider>
  );
};

export default App;
